import { IDS } from '../improvement-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../improvement.actions';
import moment from "moment/moment";

class ImprovementStepsGridController extends GridController {
    constructor($ngRedux,
                $state,
                $stateParams,
                NavigationService,
                AuthService,
                FileActions,
                $filter,
                $mdDialog,
                $scope
    ) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.rcoImprovement;
        this.statePath = IDS.improvementStepsGrid;
        this.autoload = true;
        // this.filterControls = false;
        this.filterComponent = false;
        this.exportComponent = false;
        this.filterExpandButtonVisible = false
        // this.filterComponent = false;
        // this.header = false;
        this.icon = false;
        this.title = 'Action Plan';

        const user = this.AuthService.getUser();
        this.isAdmin = user.type === 'Administrator';
        this.basicTypeName = user.basicTypeName;
        this.columns = [
            {title: '#', mapper: null},
            {title: this.$filter('translate')('COMMON.FIELD.TASK_NUMBER'),      mapper: 'task_number'},
            {title: this.$filter('translate')('COMMON.FIELD.TITLE'),            mapper: 'name'},
            {title: 'Requirement',                                              mapper: 'requirement_name'},
            {title: 'Evidence',                                                 mapper: 'evidence_name'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper: 'assignee'},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),           mapper: 'status_name'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), {
            ...Actions,
            ...this.FileActions
        })(this);
        this.unsubscribeCustom = this.$ngRedux.connect(state => ({
            improvementActionId: state.accreditation[IDS.rcoImprovement].improvementAction.uta_id
        }), {})(this);

        // this.buttons = [
        //     {label: 'Details', class: 'btnGridModify', callback: this.onSelect}
        // ];
        this.dataAction = (filter) => {
            filter.par_id = this.improvementActionId;
            this.fetchImprovementStepsGrid(filter);
        };
        this.init();
    }

    $onDestroy() {
        if(this.unsubscribeCustom)
            this.unsubscribeCustom();
        this.destroy();
    }
}

ImprovementStepsGridController.$inject = ['$ngRedux', '$state', '$stateParams', 'NavigationService', 'AuthService', 'FileActions','$filter', '$mdDialog', '$scope'];

export const improvementStepsGrid = {
    bindings: {
        onRemove: '&',
        onSelect: '&',
    },
    controller: ImprovementStepsGridController,
    ...gridTpl
}
